import { GET_PLACES, GET_SPORTS, GET_PLACES_DETAILS, RESET_PLACE_DETAILS } from '../actionTypes';

const initialState = {
  places: [],
  sports: [],
  placeDetails: null
};

const placesReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PLACES:
      return {
        ...state,
        places: action.payload
      };
    case GET_PLACES_DETAILS:
      return {
        ...state,
        placeDetails: action.payload
      };
    case RESET_PLACE_DETAILS:
      return {
        ...state,
        placeDetails: null
      };
    case GET_SPORTS:
      return {
        ...state,
        sports: action.payload
      };
    default: {
      return state;
    }
  }
};

export default placesReducer;
